import { VFC } from "react";
import { MessageDescriptor, useIntl } from "react-intl";
import { Message } from "shared/components/Message";
import { mapMessages } from "shared/mapMessages";

const messages = mapMessages("components.shared.FinishedLoadingNotification", {
    successText: "Successfully loaded {contentName}."
});

type Props = {
    contentName: MessageDescriptor | string;
};

export const FinishedLoadingNotification: VFC<Props> = ({
    contentName,
}) => {
    const intl = useIntl();
    const messageValues: { contentName: string } = { contentName: typeof contentName === "string" ? contentName : intl.formatMessage(contentName) };

    return <div role="status" aria-live="polite" className="sr-only">
        <Message message={messages.successText} values={messageValues} />
    </div>;
};
